import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useTranslation } from "react-i18next";

/**
 * DriverSelector підтримує два режими використання:
 * 1) Старий: selectedDriver (об'єкт {value,label}) + setSelectedDriver(fn)
 * 2) Новий: value (driver_id) + onChange(fn(value, option))
 */
const DriverSelector = ({
  selectedDriver,
  setSelectedDriver,
  value,
  onChange,
  className,
  activeOnly,
}) => {
  const { t } = useTranslation();

  const [drivers, setDrivers] = useState([]);

  const fixedHeightStyles =
    className === "extra-funds-driver-select"
      ? {
          control: (base) => ({ ...base, minHeight: 38, height: 38 }),
          valueContainer: (base) => ({ ...base, height: 36 }),
          indicatorsContainer: (base) => ({ ...base, height: 36 }),
        }
      : undefined;

  useEffect(() => {
    axios
      .get("/api/users", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        let list = res.data || [];
        if (activeOnly) {
          list = list.filter((u) => u.role === "user");
        }
        const formattedDrivers = list.map((driver) => ({
          value: driver.id,
          label: `${driver.firstName} ${driver.lastName}`,
        }));
        setDrivers(formattedDrivers);
      })
      .catch((err) =>
        console.error("Помилка завантаження списку водіїв:", err)
      );
  }, [activeOnly]);

  const selectedOption =
    selectedDriver ??
    (value != null
      ? drivers.find((driver) => driver.value === value) || null
      : null);

  const handleChange = (option) => {
    if (setSelectedDriver) {
      setSelectedDriver(option);
    }
    if (onChange) {
      onChange(option ? option.value : null, option);
    }
  };

  return (
    <Select
      className={className}
      options={drivers}
      value={selectedOption}
      onChange={handleChange}
      placeholder={t("chooseDriver")}
      isClearable
      isSearchable
      styles={fixedHeightStyles}
    />
  );
};

export default DriverSelector;
